import React from 'react'
import strings from '../../lang/strings'
import StarRatingCustom from '../control/star_rating'
import ReactApexChart from 'react-apexcharts'
import { API_URL, MaleUrl, optionChart, optionsXaxisAxisBorder, optionsXaxisAxisTicks, optionsXaxisLabels } from '../../config/const'
import { fphoto, htmlToText, formatNumber, string } from '../../helper/common'
import { rootStore } from '../../mobx/store'
import ConfirmButton from '../control/button/confirm_button'

export default function ItemWineeBj(props) {
  const { info, type, onDetail, onLike, goPreview } = props

  return (
    <div className='winee-bj-detail-item-area mt-20 sm-mt-15'>
      <div className='winee-bj-item-profile-area'>
        <div className='profile-image-box'>
          <img className='w-100 h-100' src={fphoto(info.mb_photo, 'member', MaleUrl)} alt={''} />
        </div>
        <div className='d-flex w-100'>
          <div className='profile-card-box'>
            <div className='profile-name'>{info.mb_nick + ' ' + strings.bj}{info.mb_new == 1 && <img className='icon_new' src='/assets/image/new.png' alt='' />}</div>
            <div className='profile-intro mt-5'>{info.mb_intro}</div>
            <div className='profile-bottom-btn-area'>
              <div onClick={onDetail} className='go-detail-btn d-center fs-15 sm-fs-12 f-m sm-none' style={{ marginTop: 'auto' }}>{strings.go_analyst}</div>
              {info.preview_dat && <ConfirmButton enabled={true} className={'preview fs-15 sm-fs-12 f-m sm-none'} text={strings.preview} onClick={goPreview}/>}
            </div>
          </div>
          <div className='profile-like-btn-area sm-none'>
            <div className='profile-btn btn-bj-like-inner cursor-point d-center' onClick={onLike}>
              <img className='star-img' src={info.mb_is_like === 1 ? '/assets/image/like_on.png' : '/assets/image/like.png'} alt='' />
              <div className='fs-12 f-m ml-12'>{strings.add_like}</div>
            </div>
          </div>
          <div className='sm-inherit cursor-point' onClick={onLike}>
            <img className='star-img'style={ {width : "28px", height : "28px" }}  src={info.mb_is_like === 1 ? '/assets/image/like_on.png' : '/assets/image/like.png'} alt='' />
          </div>
        </div>

      </div>
      <div className={`go-detail-btn-mobile`} style={{ padding: '0px 16px', marginBottom: '16px', gap : '16px'}}>
        <div onClick={onDetail} className='go-detail-btn-mobile go-detail-btn d-center fs-15 sm-fs-12 f-m'>{strings.go_analyst}</div>
        {info.preview_dat && <ConfirmButton enabled={true} className={'button-preview'} text={strings.preview} onClick={goPreview} style={{fontSize : 'inherit', borderRadius : '8px'}}/>}
      </div>

      {
        info.mb_avgUpload && 
            <div className='winee-period-info w-100'>
              {/* <div>{strings.active_period}&nbsp;:&nbsp;{info.mb_createdat.dateFormat('YYYY.MM.DD')}</div> */}
              <div>{strings.intro_avg_upload}&nbsp;:&nbsp;<span className='f-b'>{info.mb_avgUpload}</span></div>
            </div>
      }

      <div className='winee-detail-intro-area'>
        <div className='space-break' dangerouslySetInnerHTML={{ __html: htmlToText(info.mb_detail) }} />
      </div>
    </div>
  )
}

